import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { ColorPicker, Popover } from 'ui';

const BadgeEditorColorInput = ({
  value,
  title,
  name,
  disabled,
  placeholder,
  error,
  onChange = () => {},
}) => {
  const [colorPickerVisible, setColorPickerVisible] = useState(false);

  return (
    <div>
      <div className="lh-24 c-brand-gray-darker">{title}</div>
      <div className="d-f ai-c">
        <input
          className="NewInput NewInput--white f-1 fb-auto mr-8 w-fill"
          style={{ width: 'auto' }}
          type="text"
          disabled={disabled}
          placeholder={placeholder}
          name={name}
          value={value}
          onChange={onChange}
        />
        <Popover
          isHighPriority
          rootClassName="d-f"
          visible={colorPickerVisible}
          onClose={() => setColorPickerVisible(false)}
          activator={
            <button
              type="button"
              onClick={() => setColorPickerVisible(!colorPickerVisible)}
              className="u-resetBtn"
            >
              <div
                className="is-32 bdrs-2 border border-gray-light"
                style={{ backgroundColor: value }}
              />
            </button>
          }
        >
          <ColorPicker
            color={value}
            onChange={color => onChange({ target: { name, value: color } })}
          />
        </Popover>
      </div>
      <span className="d-f c-brand-red mh-24 pt-4">{error}</span>
    </div>
  );
};

BadgeEditorColorInput.propTypes = {
  value: PropTypes.string,
  title: PropTypes.string,
  name: PropTypes.string,
  placeholder: PropTypes.string,
  error: PropTypes.string,
  onChange: PropTypes.func,
};

export default BadgeEditorColorInput;
